import { render, staticRenderFns } from "./TableHeadAddDZ.vue?vue&type=template&id=29722b32&scoped=true"
import script from "./TableHeadAddDZ.vue?vue&type=script&lang=js"
export * from "./TableHeadAddDZ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29722b32",
  null
  
)

export default component.exports